import { getLogger } from '../../diagnostics/logger';
import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import {
  ENSURE_PROVISIONING_EXCLUDED_DAYS,
  INITIAL_AUTHENTICATION,
  LOAD_PROVISIONING_EXCLUDED_DAYS,
} from '../../actions/actionTypes';
import { Action, PromiseAction } from '../../actions/commonActions';
import {
  loadProvisioningExcludedDaysFailure,
  loadProvisioningExcludedDaysPending,
  loadProvisioningExcludedDaysSuccess,
} from '../../actions/simProvision/provisioningExcludedDays';
import * as simProvisionApi from '../../api/simProvisionApi';
import { ExcludedProvisioningDaysState } from '../../models/state/simProvision/simProvisionState';
import { selectExcludedProvisioningDays } from '../../selectors/simProvision';

const log = getLogger('networkTariffs.sagas');

/*
 * A saga which fetches the list of excluded provisioning days
 */
export function* loadProvisioningExcludedDaysSaga(action: PromiseAction<number[], string[]>) {
  const { payload } = action;
  if (!payload) {
    return;
  }

  yield put(loadProvisioningExcludedDaysPending(payload));
  try {
    const days: string[] = yield call(simProvisionApi.getExcludedProvisioningDays, payload);
    yield put(loadProvisioningExcludedDaysSuccess(payload, days));
    action.resolve && action.resolve(days);
  } catch (error: any) {
    yield put(loadProvisioningExcludedDaysFailure(error));
    console.error(error);
  }
}

/*
 * A saga which fetches the excluded provisioning days if needed
 */
export function* ensureProvisioningExcludedDaysSaga(action: Action<number[]>) {
  const { payload } = action;
  if (!payload) {
    return;
  }

  const excludedDays: ExcludedProvisioningDaysState = yield select(selectExcludedProvisioningDays);
  const { expiresOn, isLoading } = excludedDays;
  const now = new Date();
  const definitionIds = payload.join(',');
  if (!isLoading && (!expiresOn || expiresOn < now || definitionIds !== excludedDays.commandDefinitionIds)) {
    yield call(loadProvisioningExcludedDaysSaga, action);
  }
}

/*
 * Initializes all sagas that are related to provisioning excluded days
 */
export function* initProvisioningExcludedDaysSagas() {
  yield take(INITIAL_AUTHENTICATION);
  yield takeEvery(LOAD_PROVISIONING_EXCLUDED_DAYS, loadProvisioningExcludedDaysSaga);
  yield takeEvery(ENSURE_PROVISIONING_EXCLUDED_DAYS, ensureProvisioningExcludedDaysSaga);
}
